import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Helmet } from 'react-helmet'
import { push } from 'connected-react-router'
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons'
import clsx from 'clsx'
import { actions } from 'react-redux-form'

import Button from '../../utils/Button'

import { fetchFacility } from '../../../actions/facilitiesActions'
import { formSetFacility, formSetFacility2, formStepInc } from '../../../actions/requestFormActions'
import { matchingSiteCount } from '../../../actions/requestFormActions'

import { HeaderLarge as Header } from '../../utils/Header'

import Details from './Details'
import Content from './Content'
import Card from '../../utils/Card'

const ShowSegment = ({ className, children }) => <div className={clsx(className, 'w-full')}>{children}</div>

const Show = ({ match, ...props }) => {
  const dispatch = useDispatch()
  const fetching = useSelector(store => store.facilities.fetching)
  const facility = useSelector(store => store.facilities.facility)

  useEffect(() => {
    dispatch(fetchFacility(match.params.id))
    dispatch(actions.change('availabilityRequestForm.type', undefined))
  }, [match.params.id])

  useEffect(() => {
    if (facility.id) {
      dispatch(formSetFacility(facility.id))
      dispatch(matchingSiteCount())
    }
  }, [facility])

  const newRequest = () => {
    dispatch(formSetFacility2())
    dispatch(formStepInc())

    dispatch(push(`/new`))
  }

  return (
    <>
      <div className="md:flex space-x-0 md:space-x-4">
        <ShowSegment className="md:w-2/3 lg:w-1/2">
          <Header icon={faMapMarkerAlt} header={facility.name} subHeader={facility.subName} data-id={facility.id} />
          <div className="mt-12">
            <Details />
          </div>

          <p></p>
        </ShowSegment>

        <ShowSegment className="md:w-1/3 lg:w-1/2 mt-12 md:mt-0">
          <Card color="gray" className="prose-xl">
            <p className="font-semibold">
              Campsites at {facility.name} all sold out? Reservations full? No availability?{' '}
            </p>
            <p>Create a new request with our service and we will alert you if a campsite becomes available</p>
            <p>Try it for free! Or become a Premium member and receive text alerts</p>
            <Button onClick={newRequest} color="green" className="flex-none">
              Create Availability Request
            </Button>
          </Card>
        </ShowSegment>
      </div>
      {!fetching && <Content />}
      <Helmet>
        <title>{`${facility.name} - wanderingLabs.com - Campsite reservation and cancellation notifications`}</title>
        <meta name="description" content={facility.description} />
        <link rel="canonical" href={`https://wanderinglabs.com/f/${facility.slug}`} />
        <meta
          property="og:title"
          content={`${facility.name} - wanderingLabs.com - Campsite reservation and cancellation notification`}
        />
        <meta property="og:description" content={facility.description} />
        <meta property="og:url" content={`https://wanderinglabs.com/f/${facility.slug}`} />
      </Helmet>
    </>
  )
}

export default Show
